import React, { FC, SVGAttributes } from 'react';

const Products: FC<SVGAttributes<SVGElement>> = (props) => {
    return (
        <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M2.75012 3.25L4.83012 3.61L5.79312 15.083C5.87012 16.02 6.65312 16.739 7.59312 16.736H18.5021C19.3991 16.738 20.1601 16.078 20.2871 15.19L21.2361 8.632C21.3421 7.899 20.8331 7.219 20.1011 7.113C20.0371 7.104 5.16412 7.099 5.16412 7.099"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M14.1251 10.7949H16.8981"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.15441 20.2021C7.45541 20.2021 7.69841 20.4461 7.69841 20.7461C7.69841 21.0471 7.45541 21.2911 7.15441 21.2911C6.85341 21.2911 6.61041 21.0471 6.61041 20.7461C6.61041 20.4461 6.85341 20.2021 7.15441 20.2021Z"
                fill="currentColor"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M18.4347 20.2021C18.7357 20.2021 18.9797 20.4461 18.9797 20.7461C18.9797 21.0471 18.7357 21.2911 18.4347 21.2911C18.1337 21.2911 17.8907 21.0471 17.8907 20.7461C17.8907 20.4461 18.1337 20.2021 18.4347 20.2021Z"
                fill="currentColor"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default Products;
